import textyle from '../lib/textyle.js';
//トップページ　キービジュアルスライダー
export function idxFunc() {
  $('.target').textyle({
  duration : 400, //エフェクト時間(ミリ秒)
  delay : 50, //文字間のエフェクト間隔(ミリ秒)
  easing : 'swing', //エフェクトのイージングパターン
  callback : null //エフェクト完了後の処理（コールバック）
});
}